import { OrthographicCube } from '@/components/viewer/OrthographicCube';
import { PerspectiveCube } from '@/components/viewer/PerspectiveCube';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip';

interface OrthographicPerspectiveToggleProps {
  isOrthographic: boolean;
  onToggle: (value: boolean) => void;
}

export function OrthographicPerspectiveToggle({
  isOrthographic,
  onToggle,
}: OrthographicPerspectiveToggleProps) {
  return (
    <div className="flex items-center">
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={() => onToggle(false)}
              className={`flex h-7 w-7 items-center justify-center rounded transition-opacity hover:opacity-100 ${
                !isOrthographic ? 'opacity-100' : 'opacity-30'
              }`}
              aria-label="Perspective View"
            >
              <PerspectiveCube className="h-4 w-4 text-foreground" />
            </button>
          </TooltipTrigger>
          <TooltipContent
            side="top"
            className="flex items-center gap-2 border-border bg-background text-foreground"
          >
            <span>Perspective</span>
            <kbd className="rounded border border-border bg-muted px-1 font-mono text-xs text-muted-foreground">
              O
            </kbd>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={() => onToggle(true)}
              className={`flex h-7 w-7 items-center justify-center rounded transition-opacity hover:opacity-100 ${
                isOrthographic ? 'opacity-100' : 'opacity-30'
              }`}
              aria-label="Orthographic View"
            >
              <OrthographicCube className="h-4 w-4 text-foreground" />
            </button>
          </TooltipTrigger>
          <TooltipContent
            side="top"
            className="flex items-center gap-2 border-border bg-background text-foreground"
          >
            <span>Orthographic</span>
            <kbd className="rounded border border-border bg-muted px-1 font-mono text-xs text-muted-foreground">
              O
            </kbd>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
